export default "__VITE_ASSET__1hL9t$Uv__"